import { render } from "./SignalNoiseRatioIcon.vue?vue&type=template&id=97d85c80"
import script from "./SignalNoiseRatioIcon.vue?vue&type=script&lang=js"
export * from "./SignalNoiseRatioIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__